import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@mui/material'
import {
  Bar,
  ComposedChart,
  Label,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import BoxTitle from 'components/atoms/BoxTitle'
import { HowToReg } from '@mui/icons-material'
import { removeEmpty } from 'utils/helpers'
import { useGET_adjustmentStatsQuery } from 'redux/api/rtiApi'


const KpiAdjustmentsChart: FC<any> = ({filters = {}}) => {
  const { t } = useTranslation()

  const { data } = useGET_adjustmentStatsQuery(removeEmpty(filters) as any)

  return (
    <>{ data &&  Object.values(data).length>0 && 
    <div style={{ display: 'flex', width: '100%' }}>
      <Box className="thick-border adjustments-chart" sx={{ width: '100%' }}> 
        <Box sx={{ paddingBottom: '40px', height: '344px' }}>
          <ResponsiveContainer width='100%' height='115%'>
            <ComposedChart 
              data={Object.values(data)}
              margin={{
                top: 20,
                right: 0,
                bottom: 40
              }}
            >
              <XAxis dataKey='month' interval={0} tick={<CustomizedAxisTick />}/>
              <YAxis type='number' />
              <Legend layout="horizontal" verticalAlign="top" align="center" />
              <Tooltip />

              <Line
                type="linear"
                legendType='none' 
                hide={false}
                dataKey='count'
                stroke={"#2acea5ff"}
                strokeWidth={4}
                label={<CustomizedLabel />}
              /> 


            </ComposedChart>
          </ResponsiveContainer>
        </Box>
      </Box>
      </div> }
      </>
  )
}

export default KpiAdjustmentsChart

export const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props

  return (
    <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor='middle'>
      {`${value}`}
    </text>
  )
}
export const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} fontSize={10} textAnchor='end' fill='#666' transform='rotate(-35)'>
        {payload.value}
      </text>
    </g>
  )
}

